var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"has-float-label"},[_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder || _vm.label},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }